// `audio.sfx`: a sound effect from a description (G7-sound-types).
// Live's Sounds page chip; the Sounds forms build these. Sound takes no source.
import { AudioSfxQuote, AudioSfxRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"audio.sfx"> = {
  type: "audio.sfx",
  label: "Sound effects",
  source: "form",
  pair: "audio.sfx",
  fields: (draft) => commonFields(draft),
  request: AudioSfxRequest,
  quote: AudioSfxQuote,
};
